import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo";
import TracksMarketplacePage from "@/components/Marketplace/TracksMarketplacePage";
import { marketplaceSearchSchema } from "../-search";

export const Route = createFileRoute("/marketplace/_layout/songs")({
  validateSearch: marketplaceSearchSchema,
  component: () => <TracksMarketplacePage kind="SONG" />,
  head: () =>
    seoHead({
      title: "Buy Songs Direct From Artists | Lutely Marketplace",
      description:
        "Browse individual songs sold direct by independent artists. Buy once, own forever, and support the artist with every purchase.",
      canonicalPath: "/marketplace/songs",
    }),
});
